import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { OrderActions } from '../../actions';
import Loader from '../../components/Loader';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import TableDisplay from '../../components/Orders/TableDisplay';


export class TrackItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rows: null,
      error: null
    };
  }
  componentWillMount() {
    const { params } = this.props;
    this.props.dispatch(OrderActions.getOrderByTrackingNumber(params.tracking)).catch((error) => {
      if (error.toString() === 'Error: Not Found') {
        this.setState({ error: error.toString() });
      }
    })
  }

  goBack = () => {
    // browserHistory.push("/orders/delivered");
    browserHistory.goBack();
  }

  render() {
    // const { auth, order, params } = this.props;
    const { order, params } = this.props;
    let content;
    if (!order && !this.state.error) {
      content = (<Loader />);
    } else if (!order && this.state.error) {
      content = (<div className="row">
          <div className="col s12">
            {this.state.error}
          </div>
        </div>)
    } else {
      content = (<div className="row">
        <div className="col s12">
          <TableDisplay tracking={order} />
        </div>
      </div>);
    }
    const subnavItems = [];
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} back={this.goBack} />
          <TitleBar title={`Tracking Number: ${params.tracking}`} />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapPropsToState = (state) => {
  const { auth, orders } = state;

  return {
    auth,
    order: (orders) ? orders.order : null
  }
}

export default connect(mapPropsToState)(TrackItem);


// WEBPACK FOOTER //
// ./src/containers/TrackItem/index.js